import React from 'react'
import { Input, Form, FormGroup, Label, Container, Button } from 'reactstrap';
import { isPicture } from 'components/common/fileExplorer/fileExplorer';
import FileFolderSelector from 'components/common/fileFolderSelector/fileFolderSelector';
import IGeneral from 'model/general';
import GeneralService from 'services/generalService';
import Editor from 'components/common/editor/editor';
interface IAdminGeneralProps {

}

interface IAdminGeneralState {
    general?: IGeneral
}

class AdminGeneral extends React.Component<IAdminGeneralProps, IAdminGeneralState> {
    /**
     *
     */
    constructor(props: IAdminGeneralProps) {
        super(props);

        this.state = { general: undefined };
    }


    componentDidMount() {
        this.load();
    }

    load() {
        GeneralService.GetGeneral()
            .then(value => {
                this.setState({ general: value });
            })
    }


    saveGeneral() {
        if (this.state.general)
            GeneralService.SetGeneral(this.state.general).then(this.load.bind(this));
    }

    render() {
        if (this.state.general) {

            return (<div >
                <Container className="admin">
                    <h1>Pages</h1>
                    {Object.entries(this.state.general.Pages).map(([key, value]) => {
                        return <div key={key}>
                            <h2>Page : {key}</h2>
                            <Form>
                                <FormGroup>
                                    <Label>Titre :</Label>
                                    <Input type="text" defaultValue={value.Title} onChange={(newText) => {
                                        this.saveChangeTitle(key, newText.target.value)
                                    }} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Image :</Label>
                                    <FileFolderSelector filter={isPicture} onSelect={this.saveChangeMainPicture.bind(this, key)} value={value.PictureUrl} />
                                </FormGroup>
                            </Form>
                            <hr/>
                        </div>
                    })}
                    <h1>Présentation</h1>
                    <div className="presentation">
                        <div className="presentationHaut">
                            <h3>Présentation haut</h3>
                            <Editor id="edhaut" onChange={(newText) => {
                                if (this.state.general) {
                                    this.setState({
                                        general: {
                                            ...this.state.general,
                                            PresentationHaut: newText.target.getContentAreaContainer().innerHTML
                                        }
                                    })
                                }
                            }} initialValue={this.state.general.PresentationHaut} />
                        </div>
                        <div className="presentationMilieu">
                            <div className="presentationGauche">
                                <h3>Présentation gauche</h3>
                                <FormGroup>
                                    <Label>Image :</Label>
                                    <FileFolderSelector filter={isPicture} onSelect={(newText: string) => {
                                        if(this.state.general)
                                        this.setState({general: {
                                            ...this.state.general,
                                            PresentationPhotoGauche: newText
                                        }})
                                        }} value={this.state.general.PresentationPhotoGauche} />
                                </FormGroup>
                                <Editor id="edgauche" onChange={(newText) => {
                                    if (this.state.general) {
                                        this.setState({
                                            general: {
                                                ...this.state.general,
                                                PresentationGauche: newText.target.getContentAreaContainer().innerHTML
                                            }
                                        })
                                    }
                                }} initialValue={this.state.general.PresentationGauche} />

                            </div>
                            <div className="presentationDroite">
                                <h3>Présentation droite</h3>
                                <FormGroup>
                                    <Label>Image :</Label>
                                    <FileFolderSelector filter={isPicture} onSelect={(newText: string) => {
                                        if(this.state.general)
                                        this.setState({general: {
                                            ...this.state.general,
                                            PresentationPhotoDroite: newText
                                        }})
                                        }} value={this.state.general.PresentationPhotoDroite} />
                                </FormGroup>
                                <Editor id="eddroite" onChange={(newText) => {
                                    if (this.state.general) {
                                        this.setState({
                                            general: {
                                                ...this.state.general,
                                                PresentationDroite: newText.target.getContentAreaContainer().innerHTML
                                            }
                                        })
                                    }
                                }} initialValue={this.state.general.PresentationDroite} />

                            </div>
                        </div>
                        <div className="presentationBas">
                            <h3>Présentation bas</h3>
                            <Editor id="edbas" onChange={(newText) => {
                                if (this.state.general) {
                                    this.setState({
                                        general: {
                                            ...this.state.general,
                                            PresentationBas: newText.target.getContentAreaContainer().innerHTML
                                        }
                                    })
                                }
                            }} initialValue={this.state.general.PresentationBas} />
                        </div>
                    </div>
                    <h1>Contact</h1>
                    <Editor id="edcontact" onChange={(newText) => {
                        if (this.state.general) {
                            this.setState({
                                general: {
                                    ...this.state.general,
                                    Contact: newText.target.getContentAreaContainer().innerHTML
                                }
                            })
                        }
                    }} initialValue={this.state.general.Contact} />

                    <h1>Bas de page</h1>
                    <Editor id="edfooter" onChange={(newText) => {
                        if (this.state.general) {
                            this.setState({
                                general: {
                                    ...this.state.general,
                                    Footer: newText.target.getContentAreaContainer().innerHTML
                                }
                            })
                        }
                    }} initialValue={this.state.general.Footer} />

                    <div className="mt-5 text-right">
                        <Button color="danger" onClick={() => this.load()} className="mr-3">Annuler</Button>
                        <Button color="primary" onClick={this.saveGeneral.bind(this)}>Sauvegarder</Button>
                    </div>
                </Container>
            </div>)
        }



        return null;
    }

    saveChangeMainPicture(key: string, value: string) {
        if (!this.state.general)
            return;
        var newPage = {
            ...this.state.general.Pages,
            [key]: {
                ...this.state.general.Pages[key],
                PictureUrl: value
            }
        }
        this.setState({
            general: {
                ...this.state.general, Pages: newPage
            }
        });
    }

    saveChangeTitle(key: string, value: string) {
        if (!this.state.general)
            return;
        var newPage = {
            ...this.state.general.Pages,
            [key]: {
                ...this.state.general.Pages[key],
                Title: value
            }
        }
        this.setState({
            general: {
                ...this.state.general, Pages: newPage
            }
        });
    }
}

export default AdminGeneral;